export default __webpack_public_path__ + "static/media/logo.ce30c23e.png";